import flatpickr from "flatpickr";

/**
 * A wrapper to initialize a flatpickr input
 *
 * @param {HTMLInputElement|string} domElement
 * @param {import('flatpickr/dist/types/options').Options} settings
 * @return {import('flatpickr/dist/types/instance').Instance}
 */
function initFlatPickerInput(domElement, settings = {}) {
    // Find DOM element if a string was passed
    if (domElement instanceof String || typeof (domElement) == 'string') {
        domElement = document.querySelector(domElement);
        if (!domElement) {
            throw 'DOM Element not found';
        }
    }

    // Initialize with date on element if possible
    let defaultDate = domElement.value;
    if (!defaultDate) {
        defaultDate = new Date();
    }

    const defaultSettings = {
        defaultDate: defaultDate,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: 'm/d/Y'
    }

    const finalSettings = {
        ...defaultSettings, ...settings
    }

    if (finalSettings.enableTime) {
        // Set alt format for time, but only if it wasn't provided
        if (!settings.dateFormat) {
            finalSettings.dateFormat = 'Y-m-d h:i K'
        }
        if (!settings.altFormat) {
            finalSettings.altFormat = 'm/d/Y h:i K';
        }
    }

    // This should show no warning, but it works so who cares
    // noinspection JSValidateTypes
    return flatpickr(domElement, finalSettings);
}

export {initFlatPickerInput}
